<template>
  <div class="sd">
    <div class="container search">
      <div class="row search">
        <div class="col-md-12" style="text-align: left">
          <ul class="houseList6">
            <li class="houseList4">区域 :</li>
            <!-- <li style="width: 82%; margin-left: 5px">
              <el-checkbox-group v-model="checkListQuyu" @change="getquyu">
                <el-checkbox
                  :label="item.areaid"
                  v-for="(item, key) in checkListQuyuShow"
                  v-bind:key="key"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </li> -->
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              style="width: 82%;margin-left: 5px"
            >
              <el-tab-pane label="区域" name="quyu">
                <li>
                  <el-checkbox-group v-model="checkListQuyu" @change="getquyu">
                    <el-checkbox
                      :label="item.areaid"
                      v-for="(item, key) in checkListQuyuShow"
                      v-bind:key="key"
                      >{{ item.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </li>
              </el-tab-pane>
              <el-tab-pane
                v-if="checkListLineShow.length > 0"
                label="地铁"
                name="second"
              >
                <li>
                  <el-radio-group v-model="checkListLineKey" @change="getline">
                    <el-radio
                      :label="key1"
                      v-for="(item1, key1) in checkListLineShow"
                      v-bind:key="key1"
                      >{{ item1.line_name }}</el-radio
                    >
                  </el-radio-group>
                </li>
                <li v-if="stationShow == true" class="station">
                  <el-radio-group
                    v-model="checkListStation"
                    @change="getStation"
                  >
                    <el-radio :label="'不限'">不限</el-radio>
                    <el-radio
                      :label="item2.station"
                      v-for="(item2, key2) in checkListStationShow"
                      v-bind:key="key2"
                      >{{ item2.station }}</el-radio
                    >
                  </el-radio-group>
                </li>
              </el-tab-pane>
            </el-tabs>
          </ul>
        </div>
      </div>
      <div class="row search">
        <div class="col-md-12" style="text-align: left">
          <ul class="houseList5">
            <li class="houseList4">户型 :</li>
            <li style="margin-left: 5px">
              <el-checkbox-group v-model="checkListRoom" @change="gethuxing">
                <el-checkbox label="1">一室</el-checkbox>
                <el-checkbox label="2">二室</el-checkbox>
                <el-checkbox label="3">三室</el-checkbox>
                <el-checkbox label="4">四室</el-checkbox>
                <el-checkbox label="5">五室及以上</el-checkbox>
              </el-checkbox-group>
            </li>
          </ul>
        </div>
      </div>
      <div class="row search" id="toliulang">
        <div class="col-md-12" style="text-align: left">
          <ul class="houseList5">
            <li class="houseList4">租金 :</li>
            <li style="margin-left: 5px">
              <el-radio-group v-model="checkListRentKey" @change="getzujin">
                <el-radio
                  v-for="(item, key) in checkListRent"
                  :label="key"
                  :key="key"
                  >{{ item.name }}</el-radio
                >
                <!-- <el-radio label="5000-10000"></el-radio>
                <el-radio label="10000-15000"></el-radio>
                <el-radio label="15000-20000"></el-radio>
                <el-radio label="20000-30000"></el-radio>
                <el-radio label="≥30000"></el-radio> -->
              </el-radio-group>
            </li>
            <li>
              <el-input
                class="qujian"
                style="width: 74px"
                v-model="minRent"
              ></el-input>
              --
              <el-input
                class="qujian"
                style="width: 74px"
                v-model="maxRent"
              ></el-input>
              <el-button
                style="
                  padding: 5px 12px;
                  font-size: 12px;
                  color: #fff;
                  margin-left: 10px;
                "
                type="primary"
                @click="getQujian"
                >确定</el-button
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="row search">
        <div class="col-md-12" style="text-align: left">
          <ul class="houseList5">
            <li class="houseList4">面积 :</li>
            <li style="margin-left: 5px">
              <el-radio-group v-model="checkListSizeKey" @change="getsize">
                <el-radio
                  v-for="(item, key) in checkListSize"
                  :key="key"
                  :label="key"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </li>
            <li>
              <el-input
                class="qujian"
                style="width: 74px"
                v-model="minSize"
              ></el-input>
              --
              <el-input
                class="qujian"
                style="width: 74px"
                v-model="maxSize"
              ></el-input>
              <el-button
                style="
                  padding: 5px 12px;
                  font-size: 12px;
                  color: #fff;
                  margin-left: 10px;
                "
                type="primary"
                @click="getSizeSearch"
                >确定</el-button
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="row search" id="ghtest">
        <div class="col-md-12" style="text-align: left">
          <ul class="houseList5">
            <li class="houseList4">类型 :</li>
            <li style="margin-left: 5px">
              <el-checkbox-group v-model="checkListType" @change="getleixing">
                <el-checkbox
                  :label="item.id"
                  v-for="(item, key) in checkListTypeShow"
                  v-bind:key="key"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </li>
          </ul>
        </div>
      </div>
      <div class="row search" v-if="isshowlei == 1">
        <div class="col-md-12" style="text-align: left">
          <ul class="houseList5">
            <li class="houseList4">类目 :</li>
            <li style="margin-left: 5px">
              <el-checkbox-group v-model="checkuser" @change="getUserleixing">
                <el-checkbox label="1">个人</el-checkbox>
                <el-checkbox label="2">秒租</el-checkbox>
                <el-checkbox label="3">私盘</el-checkbox>
                <el-checkbox label="4">二房东</el-checkbox>
              </el-checkbox-group>
            </li>
          </ul>
        </div>
      </div>

      <div class="row search" v-if="isshowlei == 1">
        <div class="col-md-12" style="text-align: left">
          <ul class="houseList5">
            <li class="houseList4">编号:</li>
            <li style="margin-left: 5px">
              <el-input
                placeholder="请输入房源编号"
                v-model="room_ID"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="getroomId"
                ></el-button>
              </el-input>
            </li>
          </ul>
        </div>
      </div>
      <div class="row" id="ghtest">
        <div class="col-md-12" style="text-align: left">
          <ul class="houseList5">
            <li class="houseList4">搜索 :</li>
            <li style="margin-left: 5px">
              <el-input
                placeholder="请输入路名/小区/地铁/房屋特性..."
                v-model="inputSearch"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="getSearch"
                ></el-button>
              </el-input>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="container load"
      v-loading="loadshow"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.1)"
    >
      <div class="col-md-9 items">
        <div
          class="row houseList1"
          v-for="todo in tableData"
          @click="tohouseDetail(todo.id)"
        >
          <div class="col-md-3 thumb" style="">
            <img
              class="hot"
              v-if="todo.pinned_time"
              src="../assets/images/hot.png"
              alt=""
            />
            <p
              class="kucun"
              v-if="todo.pinned_time == null && todo.is_past_due == 1"
            >
              库存盘
            </p>
            <span
              class="tips geren"
              v-if="todo.pinned_time == null && todo.type == 1"
              >个人</span
            >
            <span
              class="tips miaozu"
              v-else-if="todo.pinned_time == null && todo.type == 2"
              >秒租</span
            >
            <span
              class="tips sipan"
              v-else-if="todo.pinned_time == null && todo.type == 3"
              >私盘</span
            >
            <span
              class="tips"
              v-else-if="todo.pinned_time == null && todo.type == 4"
              >二房东</span
            >
            <img v-if="todo.imgurl" :src="todo.imgurl" class="houseList2" />
            <img
              class="noimg"
              v-else
              src="../assets/images/zhiyeminicode.png"
              alt="../assets/images/zhiyeminicode.png"
            />
            <div v-if="!todo.imgurl" class="noimg-tips">图片拍摄中</div>
          </div>
          <div class="col-md-4 houseDetail" style="text-align: left">
            <div class="row">
              <div class="col-md-12" style="font-size: 20px;font-weight: 600">
                {{ todo.village_name }}{{ todo.building_no }}号{{
                  todo.room_no
                }}室
              </div>
            </div>
            <div class="row">
              <div class="col-md-12" style="color: #716f6f">
                {{ todo.room }} 室 {{ todo.hall }} 厅 {{ todo.bathrooms }} 卫
              </div>
            </div>
            <div class="row">
              <div v-if="todo.subway" class="col-md-12" style="color: #716f6f">
                {{ todo.houseArea.name }} | {{ todo.subway }} 号线 -
                {{ todo.station }} | {{ todo.size }} m²
              </div>
              <div v-else class="col-md-12" style="color: #716f6f">
                {{ todo.houseArea.name }} | 暂无地铁 | {{ todo.size }} m²
              </div>
            </div>

            <div class="row">
              <div class="col-md-12" style="color: #716f6f">
                <img
                  src="../assets/images/time.svg"
                  alt=""
                  style="width: 23px"
                  srcset=""
                />
                <span class="houseList3" style="">{{ todo.created_at }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-5" style="">
            <div class="row" style="margin-top: 33px">
              <div
                class="col-md-12"
                style="color: #0f7ce2; font-size: 26px;font-weight: 900;"
              >
                ¥ {{ todo.rental }}
              </div>
            </div>
            <div class="row" style="margin-top: 10px">
              <div class="col-md-12" style="">
                <span style="color: red">{{ todo.commission }}</span
                >%佣金
              </div>
            </div>

            <div class="row" style="margin-top: 30px">
              <div class="col-md-12" style="">
                <span
                  style="color: red; font-size: 13px"
                  v-if="todo.mark_time != 0"
                  >{{ todo.mark_time }} 经人工审核在租</span
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="!tableData.length" class="null">
          <img src="../assets/images/null.png" />
          <p>哎呀，空空如也！还没有人发布过相关内容哦!</p>
        </div>
      </div>

      <div class="col-md-3 recommend">
        <div class="minicode">
          <img
            src="../assets/images/houseListCode.png"
            class="index-9one"
            alt=""
          />
          <span class="indexteone">手机扫一扫，配房更高效！</span>
        </div>
        <div v-if="hotHouse.length > 0" class="hotHouseList">
          <el-row
            ><el-col :span="24">
              <div class="grid-content bg-purple tips">热门房源推荐</div>
            </el-col></el-row
          >
          <div
            v-for="item in hotHouse"
            @click="tohouseDetail(item.id)"
            class="items"
          >
            <el-row>
              <el-col :span="24"
                ><div class="grid-content bg-purple">
                  <img class="houseImg" :src="item.imgurl" alt="" /></div
              ></el-col>
            </el-row>
            <el-row class="row-bg">
              <el-col :span="14"
                ><div class="grid-content bg-purple villageName">
                  {{ item.village_name }}
                </div></el-col
              >
              <el-col :span="10"
                ><div class="grid-content bg-purple rental">
                  ¥{{ item.rental }}
                </div></el-col
              >
            </el-row>
            <el-row class="row-bg">
              <el-col :span="24"
                ><div class="grid-content bg-purple houseType">
                  {{ item.room }} 室 {{ item.hall }} 厅 {{ item.bathrooms }} 卫
                </div></el-col
              >
            </el-row>
            <el-row class="row-bg">
              <el-col :span="24"
                ><div v-if="item.subway" class="grid-content bg-purple station">
                  {{ item.houseArea.name }} | {{ item.subway }} 号线 -
                  {{ item.station }} | {{ item.size }} m²
                </div>
                <div v-else class="grid-content bg-purple station">
                  {{ item.houseArea.name }} | 暂无地铁 | {{ item.size }} m²
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" style="margin-top: 75px; margin-bottom: 43px">
        <div class="col-md-12">
          <el-pagination
            class="pagination-container"
            :background="isBackground"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="PageSize"
            layout="prev, pager, next"
            :total="totalCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import https from "../http.js";
import { getLoaction } from "../location.js";

export default {
  data() {
    return {
      isBackground: true,
      stationShow: false,
      activeName: "quyu",
      isshowlei: "",
      room_ID: "",
      tipsname: "",
      checkuser: [],
      checkListRoom: [],
      checkListQuyu: [],
      checkListQuyuShow: [],
      checkListLineKey: null,
      checkListLineShow: [],
      checkListStation: "不限",
      checkListStationShow: [],
      checkListType: [],
      checkListTypeShow: [],
      checkListRent: [],
      checkListRentKey: "",
      checkListSize: [],
      checkListSizeKey: "",
      // 搜索关键词绑定
      inputSearch: "",
      // 总数据
      tableData: [],
      hotHouse: [],
      // 默认显示第几页
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 1,
      // 个数选择器（可修改）
      // 默认每页显示的条数（可修改）
      PageSize: 10,
      loadshow: true,
      minRent: "",
      maxRent: "",
      rental: [],
      // input1: "",
      // input2: "",
      minSize: "",
      maxSize: "",
      size: [],
      shenghetime: "",
      currentProvince: "",
      currentCity: "",
      currentCityId: "",
    };
  },

  created() {
    var areaid = this.$route.query.areaid;
    var houseType = this.$route.query.houseType;
    var keyword = this.$route.query.keyword;
    if (keyword != null) {
      this.inputSearch = keyword;
    }
    if (areaid != null) {
      var areaidarray = areaid.split(",");
      this.checkListQuyu = areaidarray;
    }
    if (houseType != null) {
      var listTypeArray = houseType.split(",");
      this.checkListType = listTypeArray;
    }

    getLoaction.getLocationAddress().then((locationData) => {
      this.currentProvince = locationData.ad_info.province;
      this.currentCity = locationData.ad_info.city;
      this.currentCityId = locationData.ad_info.cityCode;

      this.getAllquyu();
      this.getLineStationData();
      this.getData(this.PageSize, this.currentPage);
    });

    // var userid = sessionStorage.getItem("userid");
    var userid = this.$cookies.get("userid");
    if (userid == null) {
      this.isshowlei = "";
    } else {
      this.isshowlei = "0";
    }
  },
  methods: {
    // 分页
    // 每页显示的条数
    handleSizeChange(val) {
      // 改变每页显示的条数
      this.PageSize = val;
      // 点击每页显示的条数时，显示第一页
      this.getData(val, 1);
      // 注意：在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1;
    },
    // 显示第几页
    handleCurrentChange(val) {
      // 改变默认的页数
      // console.log(val);
      this.currentPage = val;
      this.loadshow = true;
      // 切换页码时，要获取每页显示的条数
      this.getData(this.PageSize, val * this.pageSize);
      document.querySelector("#toliulang").scrollIntoView();
      //window.location.href = "#toliulang";
    },

    handleClick(tab, event) {},

    //房源ID内部查询
    getroomId() {
      this.getData(this.pageSize, this.currentPage);
    },

    tohouseDetail(id) {
      // this.$router.push({ path: "/HouseDetail" , query: {houseid: id}});
      let routeUrl = this.$router.resolve({
        path: "/HouseDetail",
        query: { houseid: id },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 获取区间搜索
    getQujian() {
      this.rental[0] = this.minRent;
      this.rental[1] = this.maxRent;
      if (this.minRent !== "" && this.maxRent !== "") {
        this.currentPage = 1;
        this.loadshow = true;
        this.getData(this.PageSize, this.currentPage);
      }
    },

    // 获取面积搜索
    getSizeSearch() {
      this.size[0] = this.minSize;
      this.size[1] = this.maxSize;
      if (this.maxSize !== "" && this.maxSize !== "") {
        this.currentPage = 1;
        this.loadshow = true;
        this.getData(this.PageSize, this.currentPage);
      }
    },

    // 获取个人房源，私盘
    getUserleixing(e) {
      // console.log(this.checkuser);
      this.getData(this.PageSize, this.currentPage);
    },

    getzujin() {
      const checkRentData = this.checkListRent[this.checkListRentKey];
      this.minRent = "";
      this.maxRent = "";

      this.rental[0] = checkRentData.min;
      this.rental[1] = checkRentData.max;

      this.currentPage = 1;
      this.loadshow = true;
      this.getData(this.PageSize, this.currentPage);
    },

    getsize() {
      const checkSizeData = this.checkListSize[this.checkListSizeKey];
      this.minSize = "";
      this.maxSize = "";

      this.size[0] = checkSizeData.min;
      this.size[1] = checkSizeData.max;

      this.currentPage = 1;
      this.loadshow = true;
      this.getData(this.PageSize, this.currentPage);
    },

    gethuxing() {
      this.inputSearch = "";
      this.currentPage = 1;
      this.loadshow = true;
      this.getData(this.PageSize, this.currentPage);
      //alert(this.checkListRoom)
    },

    getquyu(e) {
      //alert(this.checkListQuyu)
      //清空地铁区域选项
      this.checkListStation = "不限";
      this.checkListStationShow = [];
      this.stationShow = false;
      this.checkListLineKey = null;

      this.inputSearch = "";
      this.currentPage = 1;
      this.loadshow = true;
      this.getData(this.PageSize, this.currentPage);
    },

    getStation() {
      this.currentPage = 1;
      this.loadshow = true;
      this.getData(this.PageSize, this.currentPage);
    },

    getleixing() {
      this.currentPage = 1;
      this.inputSearch = "";
      this.loadshow = true;
      this.getData(this.PageSize, this.currentPage);
    },

    // 新增搜索功能
    getSearch() {
      this.currentPage = 1;
      this.loadshow = true;
      this.getData(this.PageSize, this.currentPage);
    },

    // 内部员工显示的搜索

    // 区域请求
    getAllquyu() {
      // var userid = sessionStorage.getItem("userid");
      var userid = this.$cookies.get("userid");
      if (userid == null) {
        userid = 0;
      }
      var param = {
        userId: userid,
        province: this.currentProvince,
        city: this.currentCity,
        cityId: this.currentCityId,
      };
      https.fetchGet("/house-list/house-list", param).then((data) => {
        console.log(data.data);
        this.checkListQuyuShow = data.data.area;
        this.checkListTypeShow = data.data.house_type;
        this.isshowlei = data.data.is_company;
        this.hotHouse = data.data.hot_house;
        this.checkListSize = data.data.size_data;
        this.checkListRent = data.data.rental_data;
      });
    },

    //地铁线数据
    getLineStationData() {
      var param = {
        city: this.currentCity,
      };
      https.fetchGet("/wechat-index/get-line-list", param).then((data) => {
        this.checkListLineShow = data.data.data;
      });
    },

    //地铁站数据
    getline() {
      this.stationShow = true;
      this.checkListQuyu = [];
      var param = {
        lineIdentifier: this.checkListLineShow[this.checkListLineKey]
          .line_identifier,
      };
      https.fetchGet("/wechat-index/get-station-data", param).then((data) => {
        this.checkListStationShow = data.data.data;
      });

      this.currentPage = 1;
      this.loadshow = true;
      this.getData(this.PageSize, this.currentPage);
    },

    // 将页码，及每页显示的条数以参数传递提交给后台
    async getData(n1, n2) {
      // var userid = sessionStorage.getItem("userid");
      var userid = this.$cookies.get("userid");
      if (userid == null) {
        userid = 0;
      }

      var line_name =
        this.checkListLineKey == null
          ? ""
          : this.checkListLineShow[this.checkListLineKey].line_name;
      var param = {
        pageSize: n1,
        page: this.currentPage,
        room: this.checkListRoom,
        province: this.currentProvince,
        city: this.currentCity,
        area: this.checkListQuyu,
        type_id: this.checkListType,
        rental: this.rental,
        keyword: this.inputSearch,
        user_id: userid,
        type: this.checkuser,
        house_num: this.room_ID,
        size: this.size,
        line: line_name,
        station: this.checkListStation,
      };

      await https
        .fetchGet("/house-list/house-list-search", param)
        .then((data) => {
          //this.tableData.push(data.data.houseList.data)
          this.tableData = data.data.houseList.data;
          // 将数据的长度赋值给totalCount
          this.totalCount = parseInt(data.data.houseList.pages.totalCount);
          this.loadshow = false;

          //console.log();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style src="../assets/css/bootstrap.min.css" scoped></style>
<style scoped>
.sd {
  background-color: #f2f2f2;
  padding-top: 40px;
}

.sd .container {
  padding: 10px 0px;
}

.container.load {
  margin-top: 20px;
}

.container.search ul li:nth-child(1) {
  font-size: 15px !important;
  font-weight: 700;
}

.container.search,
.container .items {
  background: #fff;
}

.container.search .station {
  background: #f9f9f9;
  padding: 10px 20px;
}

.search::after {
  left: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  width: 95%;
  content: "";
  height: 1px;
  background-size: 8px 1px;
  background-image: linear-gradient(90deg, #e7ebee 60%, #fff 0);
  background-repeat: repeat-x;
}

.el-checkbox {
  font-weight: normal;
  margin-right: 10px;
}

.kucun {
  position: absolute;
  top: 0;
  width: calc(100% - 30px);
  height: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  letter-spacing: 4px;
  z-index: 999;
}
li {
  display: inline-block;
}
.thumb .tips {
  display: block;
  padding: 2px 12px;
  background: #ff7ca7;
  position: absolute;
  top: 0;
  left: 15px;
  font-size: 12px;
  color: #fff;
}

.thumb .tips:after {
  content: "";
  width: 0px;
  height: 0px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #ff7ca7;
  position: absolute;
  top: 0;
  right: -10px;
}

.thumb .tips::before {
  content: "";
  position: absolute;
  display: block;
  width: 5px;
  height: 5px;
  border: 2px solid #fff;
  border-radius: 50%;
  top: 8px;
  right: 1px;
}

.thumb {
  position: relative;
}

.thumb .hot {
  position: absolute;
  width: 40px;
  top: -3px;
  left: 12px;
}

.thumb .tips.geren {
  background: #0e86e2;
}

.thumb .tips.geren::after {
  border-left: 10px solid #0e86e2;
}

.thumb .tips.miaozu {
  background: #67c23a;
}

.thumb .tips.miaozu::after {
  border-left: 10px solid #67c23a;
}

.thumb .tips.sipan {
  background: #e6a23c;
}

.thumb .tips.sipan::after {
  border-left: 10px solid #e6a23c;
}

.houseList1 {
  border-bottom: 1px solid #f5eded;
  padding-bottom: 20px;
  margin-top: 20px;
  cursor: pointer;
}

.houseList1 .houseDetail {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 150px;
}

.houseList2 {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}

.houseList3 {
  margin-left: 12px;
  margin-top: 5px;
  position: absolute;
  font-size: 14px;
}

.houseList4 {
  padding: 3px 5px;
  margin: 5px 20px;
  border-radius: 3px;
  background: #0e86e2;
  color: #fff;
}

.houseList5 {
  display: flex;
  align-items: center;
}

.houseList6 {
  display: flex;
  align-items: flex-start;
}

ul {
  margin-bottom: 0px;
}

.container .recommend {
  padding-right: 0px;
}

.container .recommend .minicode {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 280px;
  background: rgba(16, 134, 226, 0.8);
  border-radius: 10px;
  width: 100%;
  float: right;
}
.container .recommend .minicode img {
  border-radius: 20%;
  width: 200px;
  height: 200px;
}
.container .recommend .minicode .indexteone {
  color: #fff;
  font-weight: 500;
  width: 90%;
}

.row-bg {
  padding: 0px 10px;
  text-align: left;
  margin-top: 5px;
}

.recommend .hotHouseList .tips {
  text-align: left;
  font-size: 22px;
  font-weight: 900;
  margin-top: 20px;
  border-left: 6px solid #f44d4d;
  padding-left: 10px;
}

.recommend .hotHouseList .items {
  margin-top: 20px;
  background: #fff;
  border-radius: 5px;
  font-size: 13px;
  cursor: pointer;
}

.recommend .hotHouseList .items .houseImg {
  width: 100%;
  height: 150px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.recommend .hotHouseList .items .villageName {
  font-weight: 900;
  font-size: 16px;
}

.recommend .hotHouseList .items .rental {
  font-size: 18px;
  font-weight: 900;
  color: rgb(15, 124, 226);
  text-align: right;
}

.recommend .hotHouseList .items .station {
  margin-bottom: 5px;
}

.null {
  margin: 300px 200px;
}
.noimg {
  width: 100%;
  height: 150px;
}
.noimg-tips {
  text-align: center;
  position: absolute;
  top: 0;
  right: 15px;
  left: 15px;
  background: rgba(45, 45, 45, 0.7);
  color: #fff;
  font-weight: 500;
  height: 150px;
  line-height: 150px;
  font-size: 20px;
}
</style>
<style>
.pagination-container.el-pagination.is-background .el-pager li {
  background-color: #fff;
}

.input-with-select.el-input .el-input__inner {
  width: 260px;
}

.el-radio__label {
  padding-left: 0px !important;
  padding-right: 20px;
  line-height: 24px;
}

.el-radio__label,
.el-checkbox__label {
  font-size: 13px !important;
  font-weight: 500;
}

.el-radio,
.el-radio__inner,
.el-radio__input {
  display: contents !important;
}
.el-tabs__nav-wrap::after {
  width: auto !important;
}
</style>
